import axios from "axios"
import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import AxiosConfig from '../../../utilities/AxiosConfig';
//@ts-ignore
import FileViewer from "react-file-viewer"
import snackBar from "../../../utilities/snackBar/SnackBar";
import IconBuilder from "../../../utilities/iconBuilder/IconBuilder";
import DocDownloader from '../../hr/HRUtilities/DocDownloader/DocDownloader'
import { AttachmentRecordType, BillingGroupType, InvoiceType } from "../types";
import reggie from "src/utilities/Reggie";
import "./InvoiceDocViewer.css"

interface Props {
    fileName: string | null
    extension: string | null
    setShowInvoice: Function
    showInvoice: boolean;
    invoice: InvoiceType;
    attachmentRecords: AttachmentRecordType[];
    employeeID: number
    billingGroup: BillingGroupType
}

interface State {
    file: any | null
    path: string | null
    // extension: string | null
    name: string | null
    loadingFile: boolean
    download: boolean
    files: any | null
}
interface fileObject{
    url: string
    extension:string
}
class InvoiceDocViewer extends Component<Props, State> {

    state = {
        file: null,
        path: "",
        extension: null,
        name: null,
        loadingFile: false,
        download: false,
        files: [],
    }
    attachmentFiles: any[] = [];
    // extensions: any[] = [];

    componentDidMount() {        
        this.getDocument()
    }

    componentWillUnmount() {
        this.setState({
            file: null,
            path: "",
            // extension: null,
            name: null,
            loadingFile: false,
        })
    }

    base64ToFile = (base64String: any) => {
        let str = atob(base64String)
        let i = str.length
        let u8arr = new Uint8Array(i);
        while (i--) {
            u8arr[i] = str.charCodeAt(i);
        }
        return new File([u8arr], "file-preview");
    }

    getDocument = () => {
        this.setState({ loadingFile: true })
        axios.post(`${process.env.REACT_APP_API_URL}/api/ip/GetInvoiceProgressAttachment`, {
            InvoiceNumber: this.props.invoice.InvoiceNumber, 
            EmployeeID: this.props.employeeID, 
            isPDF: this.props.billingGroup.isPDF, 
            isXlsx: this.props.billingGroup.isXLSX,
            InvoiceStoreLocation: this.props.billingGroup.InvoiceStorageLocation
        }, AxiosConfig.configValue("min"))
            .then(res => {
                if(!res.data.error.success){
                    snackBar({ type: "error", text: `Error getting attachments(Please check invoice file(s) are in sharepoint): ${res.data.error.message}`, timeout: 3000 })
                    this.props.setShowInvoice(!this.props.showInvoice)
                    return
                }
                var data = res.data.data as fileObject[]
                this.setState({"files": data})
            }).catch(err => {
                this.setState({ loadingFile: false })
                snackBar({ type: "error", text: "Failed to fetch file", timeout: 3000 })
                this.props.setShowInvoice()
            })
            .finally(() =>{
                this.setState({loadingFile: false})
            })
    }

    toggleDownload = () => {
        this.setState({ download: !this.state.download })
    }

    render() {

        const state = this.state
        const props = this.props

        return (
            <div className="InvoiceDocViewer">
                <Modal id="doc-viewer-modal"
                            show={props.showInvoice}
                            backdrop="static"
                            keyboard={true}
                            centered={true}
                            size="xl"
                        >
                            <Modal.Header>
                                <h3>{`Files attached to Invoice ${props.invoice.InvoiceNumber}`}</h3>
                            </Modal.Header>
                            <Modal.Body className="InvoiceDocViewerModal">
                {
                    !this.state.loadingFile &&
                    this.state.files.map((thisFile:fileObject, idx: number) => {
                        return(
                            <div className="InvoiceDocViewerModalIndividual">
                                <div className="InvoiceDocViewerModalHeader">
                                    <IconBuilder
                                        extension={thisFile.extension}
                                        size={32}
                                    />
                                </div>
                                <div className="InvoiceDocViewerModalBody">
                                    <a href={thisFile.url} key={idx} target='_blank'>{this.props.invoice.InvoiceNumber}{thisFile.extension}</a>
                                </div>
                            </div>
                        )
                        
                    })
                }
                </Modal.Body>
                    <Modal.Footer>
                        <div className="InvoiceDocViewerModalFooter">
                            <Button 
                                id="doc-viewer-modal-footer-back-btn" 
                                variant="secondary" 
                                onClick={() => props.setShowInvoice(!props.showInvoice)}
                            >
                                Back
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default InvoiceDocViewer